<clr-modal [clrModalOpen]="messungVglModal.open()" (clrModalOpenChange)="closeModal()" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ messungVglModal.title() }}</h3>
  <div class="modal-body">
    @if (messungVglModal.open()) {
      @let graph = messungVglModal.graph;
      <!-- <app-plotly-plot [data]="graph.data()" [layout]="graph.layout()" [config]="graph.config()"/> -->
      <app-plotly-plot-modal [data]="graph.data()" [layout]="graph.layout()" [config]="graph.config()" />
    }
  </div>
</clr-modal>
